import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getStickImageStyles } from "../../utils";
import "./ProductDynamicBundleGallery.scss";
export const ProductDynamicBundleGallery = ({ imageCollection, template = "without-layout", }) => {
    //multiplicator depends on look and feel of topMargins
    const chooseMultiplicator = (template) => {
        switch (template) {
            case "layout-sticks-only":
            case "layout-2-products":
                return 0.84;
            case "layout-3-products":
                return 1.12;
            case "layout-3-products-1-horizontal":
                return 0.54;
            default:
                return 1;
        }
    };
    const renderSimpleImage = (url, index = 0) => {
        return url && _jsx("img", { className: "product-dynamic-bundle-gallery__image", src: url, alt: "" }, index);
    };
    const renderSingleStickImage = (url, index = 0, length) => {
        const multiplicator = chooseMultiplicator(template);
        const sticksWrapperStyle = getStickImageStyles(index, length, multiplicator);
        return (url && (_jsx("img", { className: "product-dynamic-bundle-gallery__image--sticks", style: sticksWrapperStyle, src: url, alt: "" }, index)));
    };
    const renderSticksContainer = (sticks, optionId) => {
        return (_jsx("div", { "data-testid": "product-dynamic-bundle-gallery__sticks-wrapper", className: `product-dynamic-bundle-gallery__sticks-wrapper`, children: _jsx("div", { className: "product-dynamic-bundle-gallery__sticks-container", children: sticks.map((url, index) => renderSingleStickImage(url, index, sticks.length)) }) }, optionId));
    };
    const renderBlockTemplate = (item) => {
        const isSticksCollection = (image) => Array.isArray(item.placeholderImage);
        return (_jsx(_Fragment, { children: isSticksCollection(item.placeholderImage)
                ? renderSticksContainer(item.placeholderImage, item.optionId)
                : renderSimpleImage(item.placeholderImage, 0) }));
    };
    return (_jsx("div", { "data-testid": "product-dynamic-bundle-gallery", className: "product-dynamic-bundle-gallery", children: _jsx("div", { "data-testid": "product-dynamic-bundle-gallery__template", className: `product-dynamic-bundle-gallery__template product-dynamic-bundle-gallery__template--${template}`, children: imageCollection.map((item) => renderBlockTemplate(item)) }) }));
};
//# sourceMappingURL=ProductDynamicBundleGallery.js.map